import { routePaths } from "@/App";
import { ChatConversation } from "@/libs/chat/components/ChatConversation";
import { Navigate, useParams } from "react-router";

export function ChatDetailPage() {
  const { id } = useParams<{ id: string }>();

  if (!id || typeof id !== "string") {
    return <Navigate to={routePaths.chat} />;
  }

  return (
    <div className="h-screen bg-white flex flex-col">
      <ChatConversation currentConversationId={id} />
    </div>
  );
}
